import { createFileRoute } from "@tanstack/react-router"

import { Stack } from "@chakra-ui/react"
import { useEffect } from "react"

import OrderInfo from "../components/OrderInfo"
import useFrame from "../hooks/useFrame"

const OrderInfoRoute: React.FC = () => {
  const { containerRef, sendHeight } = useFrame()
  useEffect(() => {
    sendHeight()
  }, [sendHeight])

  return (
    <>
      <Stack ref={containerRef}>
        <OrderInfo />
      </Stack>
    </>
  )
}

export const Route = createFileRoute("/orderinfo")({
  component: OrderInfoRoute,
})
